import { render, staticRenderFns } from "./PhoneValidator.vue?vue&type=template&id=47e11be4"
import script from "./PhoneValidator.vue?vue&type=script&lang=js"
export * from "./PhoneValidator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports